<template>
  <div class="comDetails" v-if="infoObj.infoManage">
    <div class="c-header">
      <div class="c-title">{{ infoObj.infoManage.infoName }}</div>
      <div class="clear">
        <div class="c-time fl">
          发布时间：
          <span>{{ onConversion(infoObj.infoManage.publishTime) }}</span>
        </div>
      </div>
    </div>
    <div
      class="c-main ql-snow ql-editor"
      v-html="infoObj.infoManage.infoContent"
    ></div>
    <div class="filecon" v-if="infoObj.infoManage.fileUrl.length > 0">
      <div
        v-for="(item, index) in infoObj.infoManage.fileUrl"
        :key="index"
        class="detail_file clear"
      >
        <div class="fl detail_file_tit">附件</div>

        <a
          target="_blank"
          download
          :href="$store.state.fileUrlHeader + item.url"
        >
          <div class="fl detail_file_f">
            {{ item.name }}
          </div>
        </a>
      </div>
    </div>
    <div class="c-footer clear">
      <div class="f-left">
        <router-link
          :to="'/' + baseUrl + 'Details?id=' + infoObj.last.infoId"
          v-if="infoObj.last"
          >上一条：{{ infoObj.last.infoName }}</router-link
        >
        <router-link
          :to="'/' + baseUrl + 'Details?id=' + infoObj.next.infoId"
          v-if="infoObj.next"
          >下一条：{{ infoObj.next.infoName }}</router-link
        >
      </div>
      <div class="f-right">
        <router-link :to="'/' + baseUrl" class="arows">
          返回 &nbsp; >>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "comDetails",
  props: ["infoColumn", "baseUrl"],
  data() {
    return {
      infoObj: {},
      type: this.$route.query.type,
    };
  },
  created() {
    this.getinfo();
  },
  methods: {
    returnPre() {
      this.$router.go(-1);
    },
    onConversion(date) {
      if (date.indexOf("T") === -1) {
        return this.onConversion2(date);
      } else {
        return this.onConversion1(date);
      }
    },
    // 时间转换
    onConversion2(date) {
      // console.log(1,date);
      var nDate = new Date(date.replace(new RegExp(/-/gm), "/"));
      // let nDate = new Date(date),
      var y = nDate.getFullYear(),
        m = ("0" + (nDate.getMonth() + 1)).slice(-2),
        d = ("0" + nDate.getDate()).slice(-2);
      // console.log(date)
      return y + "-" + m + "-" + d;
    },
    onConversion1(date) {
      // console.log(2,date);
      var arr = date.split("T");
      var d = arr[0];
      var darr = d.split("-");

      var dd =
        parseInt(darr[0]) +
        "-" +
        parseInt(darr[1]) +
        "-" +
        parseInt(darr[2]) +
        " ";
      return dd;
    },
    async getinfo() {
      let resQuery = this.$route.query;
      //   let res, resDatalist;
      let res = await this.$request.getNewInfoManageDetail({
        infoId: resQuery.id,
        infoColumn: this.infoColumn,
      });

      res.rows[0].infoManage.fileUrl = res.rows[0].infoManage.fileUrl
        ? JSON.parse(res.rows[0].infoManage.fileUrl)
        : [];
      //   let resNext = "";
      //   if (res.rows[0].next) {
      //     resNext = res.rows[0].next;
      //   }

      //   let resPrev = "";
      //   if (res.rows[0].last) {
      //     resPrev = res.rows[0].last;
      //   }

      //   resDatalist = {
      //     id: res.rows[0].infoManage.infoId,
      //     title: res.rows[0].infoManage.infoName,
      //     content: res.rows[0].infoManage.infoContent,
      //     fileUrl: res.rows[0].infoManage.fileUrl
      //       ? JSON.parse(res.rows[0].infoManage.fileUrl)
      //       : [],
      //     imgSrc: res.rows[0].infoManage.infoImage,
      //     index: resQuery.index,
      //     type: resQuery.type,
      //     time: this.onConversion(res.rows[0].infoManage.publishTime),
      //     next: resNext
      //       ? {
      //           id: resNext.infoId,
      //           title: resNext.infoName,
      //           index: resQuery.index - 0 + 1,
      //         }
      //       : "",
      //     prev: resPrev
      //       ? {
      //           id: resPrev.infoId,
      //           title: resPrev.infoName,
      //           index: resQuery.index - 0 - 1,
      //         }
      //       : "",
      //   };
      this.infoObj = res.rows[0];
      //   console.log(this.infoObj);
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal) {
        if (newVal.query.id) this.getinfo();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.comDetails {
  width: 1200px;
  min-height: 600px;
  margin: 60px auto;
  padding: 0 0 130px 0;
  border: solid 1px #e8e8e8;
  position: relative;
  background-color: #ffffff;
  z-index: 666;
  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 66;
  }
  .c-header {
    padding: 40px 0 40px 0;
    margin: 0 40px;
    text-align: left;
    border-bottom: 1px solid #cccccc;
    .c-title {
      display: inline-block;
      font-size: 24px;
      color: #333333;
      border-left: 10px solid $themeColor;
      padding: 0 0 0 10px;
      font-weight: bold;
    }

    .c-time {
      font-size: 16px;
      color: #666666;
      padding: 30px 0 0 0;
      font-weight: bold;
    }
  }
  .filecon {
    padding: 0 40px 45px;
    position: relative;
    .detail_file {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      border: solid 1px #eee;
      background: #ffffff;
      margin-bottom: 10px;
      /* position: absolute;
            bottom: 30px;
            left: 30px; */
      .detail_file_tit {
        width: 104px;
        text-align: center;
        background: #cccccc;
      }

      .detail_file_f {
        color: $themeColor;
        font-size: 14px;
        text-decoration: underline;
        padding-left: 10px;
      }
    }
  }

  .c-footer {
    padding: 30px 0;
    margin: 0 40px;
    border-top: 1px solid #cccccc;
    width: 1120px;
    position: absolute;
    bottom: 0;
    left: 0;

    .f-left {
      float: left;
      width: 700px;

      a {
        font-size: 16px;
        color: #666666;
        padding: 10px 0;
        width: 700px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;

        &:hover {
          color: $themeColor;
        }
      }
    }

    .f-right {
      float: right;
      width: 130px;

      .arows {
        width: 130px;
        height: 30px;
        font-size: 16px;
        line-height: 30px;
        margin-top: 26px;
        background-color: $themeColor;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>

<style lang="scss">
.c-main {
  padding: 10px 40px 20px;
  color: #333333;
  line-height: 1.5;
  img {
    max-width: 100% !important;
    display: inline-block;
    margin: 10px auto;
  }

  p {
    color: #333333;
    text-indent: 32px;
    font-size: 18px;
    line-height: 30px;
    padding: 6px 0;
  }

  span {
    color: #333333;
  }

  b {
    display: inline-block;
    font-size: 18px;
    line-height: 30px;
    padding: 10px 0;
  }

  table {
    border-collapse: collapse;
    td {
      border: 1px solid #ddd;
      padding: 5px 10px;
      box-sizing: unset;
    }
  }
}
</style>
